import React from 'react'
import { NavLink, Outlet } from 'react-router-dom'

const AdminLayout = () => {

  return (
    <div className="app admin-page">
      <div className="admin-container">
        <div className="admin-layout">
          <aside className="admin-sidebar card">
            <div className="sidebar-header">
              <h3>PersonaSphere</h3>
              <p>관리자 패널</p>
            </div>
            <ul className="admin-menu">
              {/* 기본 관리 */}
              <li className="menu-category">
                <span className="category-title">기본 관리</span>
              </li>
              <li>
                <NavLink 
                  to="/admin/confirm" 
                  className={({ isActive }) => `menu-btn ${isActive ? 'active' : ''}`}
                >
                  📝 글확정
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/admin/query" 
                  className={({ isActive }) => `menu-btn ${isActive ? 'active' : ''}`}
                >
                  🔍 DB 쿼리 도구
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/admin/settings" 
                  className={({ isActive }) => `menu-btn ${isActive ? 'active' : ''}`}
                >
                  ⚙️ 기타 설정
                </NavLink>
              </li>

              {/* YouTube API */}
              <li className="menu-category">
                <span className="category-title">YouTube API</span>
              </li>
              <li>
                <NavLink 
                  to="/admin/youtube-api" 
                  className={({ isActive }) => `menu-btn ${isActive ? 'active' : ''}`}
                >
                  📺 동영상 API
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/admin/youtube-channels-api" 
                  className={({ isActive }) => `menu-btn ${isActive ? 'active' : ''}`}
                >
                  📺 채널 API
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/admin/youtube-search-api" 
                  className={({ isActive }) => `menu-btn ${isActive ? 'active' : ''}`}
                >
                  🔍 검색 API
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/admin/youtube-playlists-api" 
                  className={({ isActive }) => `menu-btn ${isActive ? 'active' : ''}`}
                >
                  📋 재생목록 API
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/admin/youtube-comment-threads-api" 
                  className={({ isActive }) => `menu-btn ${isActive ? 'active' : ''}`}
                >
                  💬 댓글 API
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/admin/youtube-summary" 
                  className={({ isActive }) => `menu-btn ${isActive ? 'active' : ''}`}
                >
                  📝 영상 요약
                </NavLink>
              </li>

              {/* 뉴스 & 데이터 */}
              <li className="menu-category">
                <span className="category-title">뉴스 & 데이터</span>
              </li>
              <li>
                <NavLink 
                  to="/admin/news-api" 
                  className={({ isActive }) => `menu-btn ${isActive ? 'active' : ''}`}
                >
                  📰 NewsAPI
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/admin/naver-news" 
                  className={({ isActive }) => `menu-btn ${isActive ? 'active' : ''}`}
                >
                  📰 네이버 뉴스
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/admin/stock-keyword" 
                  className={({ isActive }) => `menu-btn ${isActive ? 'active' : ''}`}
                >
                  📈 주식 키워드 분석
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/admin/real-estate-auction" 
                  className={({ isActive }) => `menu-btn ${isActive ? 'active' : ''}`}
                >
                  🏠 부동산 경매
                </NavLink>
              </li>
            </ul>
          </aside>

          <main className="admin-content card">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  )
}

export default AdminLayout


